var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 183,
    height: 54.222,
    viewBox: "0 0 183 54.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a6a5a5;}.b,.i,.j{fill:#fff;}.c{fill:url(#a);}.d{fill:url(#b);}.e{fill:url(#c);}.f{fill:url(#d);}.g{opacity:0.2;}.g,.h,.i{isolation:isolate;}.h{opacity:0.12;}.i{opacity:0.25;}.j{stroke:#fff;stroke-miterlimit:10;stroke-width:0.2px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.915,
    y1: 5.258,
    x2: -0.383,
    y2: 4.589,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4896d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#4998d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#43b9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#3fc6f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#55c8e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ac8e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.076,
    y1: 13.125,
    x2: -1.305,
    y2: 13.125,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#fdbc11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#f9a31a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89b1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.862,
    y1: 8.219,
    x2: -0.501,
    y2: 6.45,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee4049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c21e64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.188,
    y1: 10.939,
    x2: 0.421,
    y2: 10.149,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#319f71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2ba772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#4cb970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#5fbc6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66bd68"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.443)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.443)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182.416,
    height: 52.831,
    rx: 7,
    transform: "translate(0 0.638)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M327.286,78.084a5.7,5.7,0,0,1,5.693,5.693v40.667a5.7,5.7,0,0,1-5.693,5.693H157.842a5.7,5.7,0,0,1-5.693-5.693V83.778a5.7,5.7,0,0,1,5.693-5.693H327.286m0-1.084H157.842a6.8,6.8,0,0,0-6.778,6.778v40.667a6.8,6.8,0,0,0,6.778,6.778H327.286a6.8,6.8,0,0,0,6.778-6.778V83.778A6.8,6.8,0,0,0,327.286,77Z",
    transform: "translate(-151.064 -77)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M228.832,100.425a5.765,5.765,0,1,0,5.788,5.765A5.682,5.682,0,0,0,228.832,100.425Zm0,9.258a3.5,3.5,0,1,1,3.255-3.493A3.335,3.335,0,0,1,228.832,109.683Zm-12.624-9.258a5.765,5.765,0,1,0,5.787,5.765A5.682,5.682,0,0,0,216.208,100.425Zm0,9.258a3.5,3.5,0,1,1,3.253-3.493A3.334,3.334,0,0,1,216.208,109.683Zm-15.018-7.491v2.447h5.853a5.1,5.1,0,0,1-1.332,3.078,5.987,5.987,0,0,1-4.521,1.791,6.508,6.508,0,0,1,0-13.015A6.246,6.246,0,0,1,205.6,98.24l1.724-1.724a8.531,8.531,0,0,0-6.137-2.468,8.955,8.955,0,1,0,0,17.908,8.188,8.188,0,0,0,6.246-2.512,8.818,8.818,0,0,0,1.987-7.251Zm61.419,1.9a5.358,5.358,0,0,0-4.936-3.668,5.479,5.479,0,0,0-5.439,5.765,5.642,5.642,0,0,0,5.722,5.765,5.734,5.734,0,0,0,4.8-2.555l-1.966-1.311a3.29,3.29,0,0,1-2.838,1.594,2.932,2.932,0,0,1-2.8-1.747l7.709-3.188Zm-7.862,1.922a3.162,3.162,0,0,1,3.013-3.363,2.233,2.233,0,0,1,2.14,1.223Zm-6.268,5.59h2.534V94.658h-2.534Zm-4.149-9.893h-.087a4,4,0,0,0-3.036-1.288,5.77,5.77,0,0,0,0,11.53,3.931,3.931,0,0,0,3.036-1.311h.087v.83c0,2.207-1.179,3.385-3.08,3.385a3.189,3.189,0,0,1-2.9-2.052l-2.206.918a5.494,5.494,0,0,0,5.109,3.407c2.971,0,5.482-1.747,5.482-6.005V100.773h-2.4Zm-2.9,7.971a3.507,3.507,0,0,1,0-6.988,3.522,3.522,0,0,1,0,6.988Zm33.05-15.024h-6.061v16.946h2.53v-6.42h3.531a5.271,5.271,0,1,0,0-10.526Zm.066,8.167h-3.6V97.018h3.6a2.9,2.9,0,1,1,0,5.809Zm15.631-2.433a4.749,4.749,0,0,0-4.513,2.593l2.246.938a2.394,2.394,0,0,1,2.31-1.243,2.436,2.436,0,0,1,2.661,2.18v.175a5.6,5.6,0,0,0-2.638-.653c-2.421,0-4.884,1.33-4.884,3.815,0,2.268,1.983,3.728,4.208,3.728a3.566,3.566,0,0,0,3.226-1.656h.088v1.308h2.441v-6.5C295.317,102.072,293.071,100.394,290.171,100.394Zm-.3,9.287c-.828,0-1.983-.415-1.983-1.44,0-1.308,1.438-1.808,2.681-1.808a4.5,4.5,0,0,1,2.311.567A3.066,3.066,0,0,1,289.866,109.681Zm14.346-8.917-2.9,7.347h-.088l-3.008-7.347h-2.725L300,111.032l-2.573,5.712h2.638l6.955-15.981Zm-22.783,10.842h2.529V94.66h-2.529Z",
    transform: "translate(-136.472 -70.939)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.518 9.679)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M161.664,84.564a2.714,2.714,0,0,0-.628,1.9v29.979a2.712,2.712,0,0,0,.628,1.9l.1.1,16.794-16.794v-.4l-16.794-16.8Z",
    transform: "translate(-161.036 -84.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M179.559,104.319l-5.6-5.6v-.4l5.6-5.6.126.072,6.633,3.768c1.9,1.076,1.9,2.839,0,3.915l-6.633,3.768Z",
    transform: "translate(-156.44 -81.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M184.118,102.727,178.393,97,161.5,113.9c.625.662,1.655.743,2.817.083l19.8-11.251",
    transform: "translate(-160.871 -79.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M184.118,95.848,164.316,84.6c-1.162-.659-2.192-.577-2.817.084l16.894,16.894Z",
    transform: "translate(-160.871 -84.14)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.033)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M183.992,101.132l-19.676,11.179a2.259,2.259,0,0,1-2.717.015h0l-.1.1h0l.1.1h0a2.257,2.257,0,0,0,2.717-.015l19.8-11.251Z",
    transform: "translate(-160.871 -101.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M161.664,109.818a2.714,2.714,0,0,1-.628-1.9v.2a2.712,2.712,0,0,0,.628,1.9l.1-.1Z",
    transform: "translate(-161.036 -98.721)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M184.851,98.76l-6.759,3.84.126.126,6.633-3.768A2.379,2.379,0,0,0,186.273,97h0A2.527,2.527,0,0,1,184.851,98.76Z",
    transform: "translate(-154.972 -79.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M164.48,84.795l26.435,15.02a2.525,2.525,0,0,1,1.422,1.76h0a2.38,2.38,0,0,0-1.422-1.957L164.48,84.6c-1.9-1.076-3.444-.183-3.444,1.987v.2C161.036,84.613,162.585,83.718,164.48,84.795Z",
    transform: "translate(-161.036 -84.14)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.035 7.842)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M192.4,92.133V84h2.487a4.043,4.043,0,0,1,3,1.131,4.4,4.4,0,0,1,0,5.872,4.043,4.043,0,0,1-3,1.131Zm1.045-1h1.442a3.052,3.052,0,0,0,2.233-.808A3.073,3.073,0,0,0,194.888,85h-1.442Z",
    transform: "translate(-192.401 -81.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M198.36,92.133V84h1.045v8.133Z",
    transform: "translate(-190.282 -81.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M202.942,92.363a3.031,3.031,0,0,1-1.731-.579,2.679,2.679,0,0,1-1.107-1.625l.954-.385a2.184,2.184,0,0,0,.7,1.129,1.766,1.766,0,0,0,1.187.46,1.906,1.906,0,0,0,1.166-.357,1.146,1.146,0,0,0,.481-.972,1.246,1.246,0,0,0-.481-1.051,4.983,4.983,0,0,0-1.528-.687,4.068,4.068,0,0,1-1.636-.881,1.835,1.835,0,0,1-.557-1.38,2.015,2.015,0,0,1,.693-1.521,2.536,2.536,0,0,1,1.806-.648,2.617,2.617,0,0,1,1.682.516,2.393,2.393,0,0,1,.84,1.131l-.953.4a1.42,1.42,0,0,0-.506-.716,1.777,1.777,0,0,0-2.069.005,1.025,1.025,0,0,0-.426.835.947.947,0,0,0,.392.767,3.775,3.775,0,0,0,1.152.563,9.778,9.778,0,0,1,1.007.375,4.5,4.5,0,0,1,.816.481,1.931,1.931,0,0,1,.625.751,2.408,2.408,0,0,1,.21,1.038,2.243,2.243,0,0,1-.243,1.057,2.014,2.014,0,0,1-.649.739,3.267,3.267,0,0,1-1.823.556Z",
    transform: "translate(-189.663 -81.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M206.351,92.133h-1.044V84h2.772a2.569,2.569,0,0,1,1.788.687,2.361,2.361,0,0,1,0,3.463,2.564,2.564,0,0,1-1.788.689h-1.728Zm0-4.294h1.75a1.352,1.352,0,0,0,1.057-.442,1.4,1.4,0,0,0,0-1.955A1.353,1.353,0,0,0,208.1,85h-1.75Z",
    transform: "translate(-187.812 -81.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M216.986,91.13a4.225,4.225,0,0,1-5.964,0,4.395,4.395,0,0,1,0-6.032,4.212,4.212,0,0,1,5.959.005,4.384,4.384,0,0,1,.005,6.027Zm-5.193-.682a3.129,3.129,0,0,0,4.419,0,3.465,3.465,0,0,0,0-4.669,3.125,3.125,0,0,0-4.419,0,3.469,3.469,0,0,0,0,4.669Z",
    transform: "translate(-186.206 -81.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M217.072,92.133V84h1.273l3.953,6.326h.045l-.045-1.567V84h1.045v8.133h-1.09L218.117,85.5h-.045l.045,1.568v5.066Z",
    transform: "translate(-183.629 -81.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M223.072,92.682V84.548h1.045v8.133Zm.977-8.769h-.91l.592-1.455h1.136Z",
    transform: "translate(-181.496 -82.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M227.451,92.133,224.589,84h1.158l2.227,6.6h.045l2.318-6.6H231.5l-2.954,8.133Z",
    transform: "translate(-180.956 -81.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M235.3,85h-3.7v2.58h3.34v.976H231.6v2.58h3.7v1h-4.749V84H235.3Z",
    transform: "translate(-178.835 -81.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M235.266,92.133V84h1.044v7.134h3.522v1Z",
    transform: "translate(-177.16 -81.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M241.617,92.133V84h1.273l3.953,6.326h.045l-.045-1.567V84h1.045v8.133H246.8L242.662,85.5h-.045l.045,1.568v5.066Z",
    transform: "translate(-174.902 -81.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M254.4,91.13a4.225,4.225,0,0,1-5.964,0,4.395,4.395,0,0,1,0-6.032,4.212,4.212,0,0,1,5.959.005,4.384,4.384,0,0,1,.005,6.027Zm-5.193-.682a3.129,3.129,0,0,0,4.419,0,3.465,3.465,0,0,0,0-4.669,3.125,3.125,0,0,0-4.419,0,3.469,3.469,0,0,0,0,4.669Z",
    transform: "translate(-172.903 -81.957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.4c55a07bf8d30a7e2e197fda9dbecb0c.svg";
export { ForwardRef as ReactComponent };